import {Component, OnDestroy, OnInit, ViewChildren, ElementRef, QueryList} from '@angular/core';
import {Router} from '@angular/router';
import {ConfigService} from '../config/config.service';
import { backendAddress } from '../../environments/environment';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';
import {Meta, Title} from '@angular/platform-browser';
import {LanguageService} from '../service/language.service';

@Component({
    selector: 'app-market',
    templateUrl: './market.component.html',
    styleUrls: ['./market.component.scss'],
    standalone: false
})
export class MarketComponent implements OnInit, OnDestroy {
  @ViewChildren('lazyElement', { read: ElementRef }) lazyElements!: QueryList<ElementRef>;
  router: Router;

  constructor(private privateRouter: Router, private api: ConfigService,
              private snackBar: MatSnackBar, private translate: TranslateService,
              // tslint:disable-next-line:variable-name
              private meta: Meta, private meta_title: Title, private _language: LanguageService) {
    this.router = privateRouter;
    this._language.current_lang.subscribe(lang => {
      if (lang === 0 ) {
        translate.use('ro');
      } else {
        translate.use('en');
      }
    });
  }

  isLoaderVisible = false;
  categories = [
    { id: 0, name: 'Toate Categoriile' }
  ];
  artists = [{
      id: 0,
      first_name: '',
      last_name: '',
      email: '',
      phone_number: '',
      agreed_term_conditions: 0,
      agreed_contacted_via_mail: 0,
      agreed_contacted_via_phone: 0,
      role_id: 0,
      created_at: '',
      updated_at: '',
      full_name: 'Toti artistii',
    }];
  artObjects = [
    {
      id: 0,
      title: '',
      description: '',
      dimension: '',
      year: 0,
      file_name:  '',
      file_path:  ''
    }
  ];
  isUserLoggedIn = false;
  userRole = 0;
  user: any;
  isMarketReady = true;
  backendAddress = backendAddress.value;
  email = '';
  url: any;
  selectedArtistId = 0;
  selectedCategoryId = 0;
  selectedArtistName = '';

  getArtObjects(): void {
    this.isLoaderVisible = true;
    if (this.selectedCategoryId !== 0){
      this.filterByCategory();
    } else {
      this.api.getAllArtObjects().subscribe(data => {
          this.finishGet(data);
        },
        error => {
          this.finishGetWithError(error);
        });
    }
  }
  getArtistName(): void {
    this.api.getUserById(this.selectedArtistId.toString()).subscribe(data => {
      // @ts-ignore
      this.selectedArtistName = data.full_name;
      this.router.navigate(['Market/' + this.selectedArtistId + '/' + this.selectedArtistName.replace(/[\s\/]+/g, '-')]);
      this.getArtObjectsByArtists(this.selectedArtistId);
    },
      error => {
        this.finishGetWithError(error);
      });
  }

  selectionChangeArtistId(artistId: string): void {
    if (artistId === '0'){
      this.router.navigate(['Market/0/all']);
      this.getArtObjects();
    } else {
      this.getArtistName();
    }
  }
  selectionChangeCategoryId(categoryId: string): void {
    localStorage.setItem('marketCategoryId', categoryId);
    this.checkFiltersIds();
  }

  getArtObjectsByArtists(artistId: number): void {
    this.isLoaderVisible = true;
    this.selectedArtistId = artistId;

    if (this.selectedCategoryId !== 0){
      this.filterByCategory();
    } else {
      this.api.getFilterArtObjectsByArtist(artistId).subscribe(data => {
          this.finishGet(data);
        },
        error => {
          this.finishGetWithError(error);
        });
    }
  }
  getFilters(): void {
    this.api.postUpsertDropdowns().subscribe(data => {
      // @ts-ignore
      if (data) {
        // @ts-ignore
        data.painting_categories.forEach(category => {
          this.categories.push(category);
        });
      }
    }, err => {
      this.translate.get('errorOccurred').subscribe(message => {
        this.snackBar.open(message, '',
          {duration: 3000, panelClass: 'error-snack-bar',
            horizontalPosition: 'end', verticalPosition: 'top'});
      });
    });
    this.api.getArtists().subscribe(artists => {
      // @ts-ignore
      if (artists){
        // @ts-ignore
        artists.forEach(artist => {
          this.artists.push(artist);
        });
      }
    }, error => {
        this.finishGetWithError(error);
      });
  }
  getLoggedInUser(): void {
    this.api.getLoggedUser().subscribe(
      user => {
        if (user) {
          this.user = user;
          this.isUserLoggedIn = true;
          // @ts-ignore
          this.userRole = user.role_id;
        }
        this.isLoaderVisible = false;
      });
    // todo
    // this.isUserLoggedIn = true;
    // this.isLoaderVisible = true;
  }
  checkUrl(): void {
    this.url = location.href.split('/');
    this.selectedArtistId = Number(this.url[this.url.length - 2]);
    this.selectedCategoryId = Number(localStorage.getItem('marketCategoryId'));
  }
  checkFiltersIds(): void {
    this.isLoaderVisible = true;
    if (this.selectedArtistId === 0){
      this.getArtObjects();
    } else {
      this.getArtObjectsByArtists(this.selectedArtistId);
    }
  }
  filterByCategory(): void {
    if (this.selectedArtistId !== 0 ){
      this.api.getFilteredArtObjects(this.selectedCategoryId, this.selectedArtistId).subscribe(data => {
        this.finishGet(data);
      }, error => {
        this.finishGetWithError(error);
      });
    } else {
      this.api.getFilterArtObjectsByCategory(this.selectedCategoryId).subscribe(data => {
        this.finishGet(data);
      }, error => {
        this.finishGetWithError(error);
      });
    }
  }
  finishGetWithError(error: string): void {
    console.log('error', error);
    this.isLoaderVisible = false;
    this.isMarketReady = true;
    this.translate.get('errorOccurred').subscribe(message => {
      this.snackBar.open(message, '',
        {duration: 3000, panelClass: 'error-snack-bar',
          horizontalPosition: 'end', verticalPosition: 'top'});
    });
  }
  finishGet(artObj: any): void {
    this.artObjects = artObj.reverse();
    setTimeout(() => {
      this.isMarketReady = true;
      this.isLoaderVisible = false;
      this.initializeIntersectionObserver();
    }, 0);
  }
  constructDropdowns(): void {
    this.translate.get('allCategories').subscribe(message => {
      this.categories = [
        { id: 0, name: message }
      ];
    });
    this.translate.get('allArtists').subscribe(message => {
      this.artists = [{
        id: 0,
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        agreed_term_conditions: 0,
        agreed_contacted_via_mail: 0,
        agreed_contacted_via_phone: 0,
        role_id: 0,
        created_at: '',
        updated_at: '',
        full_name: message,
      }];
    });
  }
  initializeIntersectionObserver(): void {
    // tslint:disable-next-line:no-shadowed-variable
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    this.lazyElements.forEach(element => observer.observe(element.nativeElement));
  }
  seeDetails(categoryId: string, artObjectId: string): void {
    this.router.navigate(['Art/' + categoryId + '/' + artObjectId]);
  }
  async ngOnInit(): Promise<void> {
    this.meta_title.setTitle('Marketplace - Lupul Creativ');
    this.meta.updateTag({ name: 'description', content: 'Vizitează galeria noastră formată din operele de artă a mai multor artiști contemporani' });
    this.meta.updateTag({ name: 'keywords', content: 'galerie de artă, picturi, artă originală, lucrări personalizate' });

    this.isMarketReady = false;
    localStorage.removeItem('marketCategoryId');

    await this.constructDropdowns();
    await this.getLoggedInUser();
    await this.getFilters();
    this.checkUrl();
    this.checkFiltersIds();
  }
  ngOnDestroy(): void {
    localStorage.removeItem('marketCategoryId');
  }
}
